import { connect } from 'react-redux';
import AlbumView from './index'
import {loadAlbum, removePhoto, clearAlbum} from '../../actions/Albums'
const mapStateToProps = (state, props) => {

    return {
	album: state.albums.current,
	authenticated: state.session.authenticated
    }
}

const mapDispatchToProps = (dispatch, state) => {
    return {
	loadAlbum: (id) => dispatch(loadAlbum(id)),
	removePhoto: (album_id, image_id) => dispatch(removePhoto(image_id)).then(() => dispatch(loadAlbum(album_id))),
	clearAlbum: () => dispatch(clearAlbum()),
    }
}

const AlbumContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(AlbumView);




export default AlbumContainer;



// WEBPACK FOOTER //
// ./src/components/Album/Container.js